import { Controller } from "@hotwired/stimulus"
import { animate, inView } from "motion"

// Scroll-reveal for marketing pages. Attach once to a wrapper; every
// [data-reveal] inside fades/slides in the first time it scrolls into view.
// Progressive enhancement: elements stay fully visible without JS, and
// prefers-reduced-motion leaves the page static.
export default class extends Controller {
  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.stops = Array.from(this.element.querySelectorAll("[data-reveal]")).map((item) => {
      item.style.opacity = "0"
      item.style.transform = "translateY(24px)"
      return inView(
        item,
        () => {
          animate(
            item,
            { opacity: 1, transform: "translateY(0px)" },
            { duration: 0.55, delay: Number(item.dataset.revealDelay || 0), ease: [0.22, 1, 0.36, 1] }
          )
        },
        { amount: 0.25 }
      )
    })
  }

  disconnect() {
    this.stops?.forEach((stop) => stop())
  }
}
